import { render, staticRenderFns } from "./PvImprecionViewer.vue?vue&type=template&id=99d73348&"
import script from "./PvImprecionViewer.vue?vue&type=script&lang=js&"
export * from "./PvImprecionViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol})
